function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/// <reference types="@pansy/amap-types" />

import { LoadStatus, defaultConfig } from "./config";
import { getScriptSrc } from "./utils";
var Status = {
  AMap: LoadStatus.notload,
  AMapUI: LoadStatus.notload,
  Loca: LoadStatus.notload
};
var Callback = {
  AMap: [],
  AMapUI: [],
  Loca: []
};
var config = _objectSpread({}, defaultConfig);
var onloadCBKs = [];
function onload(callback) {
  if (typeof callback == "function") {
    if (Status.AMap === LoadStatus.loaded) {
      callback(window.AMap);
      return;
    }
    onloadCBKs.push(callback);
  }
}
;

/**
 * 加载其他资源
 * @param option
 * @returns
 */
function appendOther(option) {
  var promises = [];
  if (option.AMapUI) {
    promises.push(loadAMapUI(option.AMapUI));
  }
  if (option.Loca) {
    promises.push(loadLoca(option.Loca));
  }
  return Promise.all(promises);
}
export function loadAMapUI(params) {
  return new Promise(function (resolve, reject) {
    var newPlugins = [];
    if (params.plugins) {
      for (var i = 0; i < params.plugins.length; i += 1) {
        if (config.AMapUI.plugins.indexOf(params.plugins[i]) == -1) {
          newPlugins.push(params.plugins[i]);
        }
      }
    }
    if (Status.AMapUI === LoadStatus.failed) {
      reject('前次请求 AMapUI 失败');
      return;
    }
    if (Status.AMapUI === LoadStatus.notload) {
      Status.AMapUI = LoadStatus.loading;
      config.AMapUI.version = params.version || config.AMapUI.version;
      var version = config.AMapUI.version;
      var parentNode = document.body || document.head;
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://webapi.amap.com/ui/".concat(version, "/main.js");
      script.onerror = function (e) {
        Status.AMapUI = LoadStatus.failed;
        reject('请求 AMapUI 失败');
      };
      script.onload = function () {
        Status.AMapUI = LoadStatus.loaded;
        if (newPlugins.length) {
          window.AMapUI.loadUI(newPlugins, function () {
            for (var _i = 0, len = newPlugins.length; _i < len; _i++) {
              var path = newPlugins[_i];
              var name = path.split('/').slice(-1)[0];
              window.AMapUI[name] = arguments[_i];
            }
            resolve();
            while (Callback.AMapUI.length) {
              Callback.AMapUI.splice(0, 1)[0]();
            }
          });
        } else {
          resolve();
          while (Callback.AMapUI.length) {
            Callback.AMapUI.splice(0, 1)[0]();
          }
        }
      };
      parentNode.appendChild(script);
      return;
    }
    if (Status.AMapUI === LoadStatus.loaded) {
      if (params.version && params.version !== config.AMapUI.version) {
        reject('不允许多个版本 AMapUI 混用');
      } else {
        if (newPlugins.length) {
          window.AMapUI.loadUI(newPlugins, function () {
            for (var _i2 = 0, len = newPlugins.length; _i2 < len; _i2++) {
              var path = newPlugins[_i2];
              var name = path.split("/").slice(-1)[0];
              window.AMapUI[name] = arguments[_i2];
            }
            resolve();
          });
        } else {
          resolve();
        }
      }
      return;
    }
    if (params.version && params.version !== config.AMapUI.version) {
      reject('不允许多个版本 AMapUI 混用');
    } else {
      Callback.AMapUI.push(function (err) {
        if (err) {
          reject(err);
        } else {
          if (newPlugins.length) {
            window.AMapUI.loadUI(newPlugins, function () {
              for (var _i3 = 0, len = newPlugins.length; _i3 < len; _i3++) {
                var path = newPlugins[_i3];
                var name = path.split("/").slice(-1)[0];
                window.AMapUI[name] = arguments[_i3];
              }
              resolve();
            });
          } else {
            resolve();
          }
        }
      });
    }
  });
}
export function loadLoca(params) {
  return new Promise(function (resolve, reject) {
    if (Status.Loca === LoadStatus.failed) {
      reject('前次请求 Loca 失败');
      return;
    }
    if (Status.Loca === LoadStatus.notload) {
      Status.Loca = LoadStatus.loading;
      config.Loca.version = params.version || config.Loca.version;
      var version = config.Loca.version;
      var isApiV2 = config.AMap.version.startsWith('2');
      var isLocaV2 = version.startsWith('2');
      if (isApiV2 && !isLocaV2 || !isApiV2 && isLocaV2) {
        reject('JSAPI 与 Loca 版本不对应！！');
        return;
      }
      var key = config.key;
      var parentNode = document.body || document.head;
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://webapi.amap.com/loca?v=".concat(version, "&key=").concat(key);
      script.onerror = function () {
        Status.Loca = LoadStatus.failed;
        reject('请求 Loca 失败');
      };
      script.onload = function () {
        Status.Loca = LoadStatus.loaded;
        resolve();
        while (Callback.Loca.length) {
          Callback.Loca.splice(0, 1)[0]();
        }
      };
      parentNode.appendChild(script);
      return;
    }
    if (Status.Loca === LoadStatus.loaded) {
      if (params.version && params.version !== config.Loca.version) {
        reject('不允许多个版本 Loca 混用');
      } else {
        resolve();
      }
      return;
    }
    if (params.version && params.version !== config.Loca.version) {
      reject('不允许多个版本 Loca 混用');
    } else {
      Callback.Loca.push(function (err) {
        if (err) {
          reject(err);
        } else {
          reject();
        }
      });
    }
  });
}
export function load(opts) {
  return new Promise(function (resolve, reject) {
    /** 加载失败 */
    if (Status.AMap == LoadStatus.failed) {
      reject();
      return;
    }

    /** 未加载 */
    if (Status.AMap == LoadStatus.notload) {
      var _opts$key = opts.key,
        key = _opts$key === void 0 ? config.key : _opts$key,
        _opts$version = opts.version,
        version = _opts$version === void 0 ? config.AMap.version : _opts$version,
        _opts$plugins = opts.plugins,
        plugins = _opts$plugins === void 0 ? [] : _opts$plugins;
      config.key = key;
      config.AMap.version = version;
      config.AMap.plugins = plugins;
      Status.AMap = LoadStatus.loading;
      var parentNode = document.body || document.head;
      window.__amap_init_callback = function (err) {
        delete window.__amap_init_callback;
        if (err) {
          Status.AMap = LoadStatus.failed;
          reject(err);
          return;
        }
        Status.AMap = LoadStatus.loaded;
        appendOther(opts).then(function () {
          resolve(window.AMap);
        }).catch(reject);
        while (onloadCBKs.length) {
          onloadCBKs.splice(0, 1)[0]();
        }
      };
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = getScriptSrc(config);
      script.onerror = function (e) {
        Status.AMap = LoadStatus.failed;
        reject(e);
      };
      parentNode.appendChild(script);
      return;
    }

    /** 加载中 */
    if (Status.AMap == LoadStatus.loaded) {
      if (opts.key && opts.key !== config.key) {
        reject('多个不一致的 key');
        return;
      }
      if (opts.version && opts.version !== config.AMap.version) {
        reject('不允许多个版本 JSAPI 混用');
        return;
      }
      var _newPlugins = [];
      if (opts.plugins) {
        for (var i = 0; i < opts.plugins.length; i += 1) {
          if (config.AMap.plugins.indexOf(opts.plugins[i]) == -1) {
            _newPlugins.push(opts.plugins[i]);
          }
        }
      }
      if (_newPlugins.length) {
        window.AMap.plugin(_newPlugins, function () {
          appendOther(opts).then(function () {
            resolve(window.AMap);
          }).catch(reject);
        });
      } else {
        appendOther(opts).then(function () {
          resolve(window.AMap);
        }).catch(reject);
      }
      return;
    }

    /** 加载中 */
    if (opts.key && opts.key !== config.key) {
      reject('多个不一致的 key');
      return;
    }
    if (opts.version && opts.version !== config.AMap.version) {
      reject('不允许多个版本 JSAPI 混用');
      return;
    }
    var newPlugins = [];
    if (opts.plugins) {
      for (var i = 0; i < opts.plugins.length; i += 1) {
        if (config.AMap.plugins.indexOf(opts.plugins[i]) == -1) {
          newPlugins.push(opts.plugins[i]);
        }
      }
    }
    onload(function () {
      if (newPlugins.length) {
        window.AMap.plugin(newPlugins, function () {
          appendOther(opts).then(function () {
            resolve(window.AMap);
          }).catch(reject);
        });
      } else {
        appendOther(opts).then(function () {
          resolve(window.AMap);
        }).catch(reject);
      }
    });
  });
}
export function reset() {
  delete window.AMap;
  delete window.AMapUI;
  delete window.Loca;
  config = _objectSpread({}, defaultConfig);
  Status = {
    AMap: LoadStatus.notload,
    AMapUI: LoadStatus.notload,
    Loca: LoadStatus.notload
  };
  Callback = {
    AMap: [],
    AMapUI: [],
    Loca: []
  };
}